// Angular
import {Component, ElementRef, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {LayoutConfigService, SplashScreenService} from '../../../core/_base/layout';

@Component({
  selector: 'kt-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {
  // Public properties
  today: number = Date.now();
  headerLogo: string;
  language = 'en';

  constructor(private el: ElementRef,
              private render: Renderer2,
              private layoutConfigService: LayoutConfigService,
              private splashScreenService: SplashScreenService) {
  }

  ngOnInit(): void {
    this.headerLogo = this.layoutConfigService.getLogo();
    this.splashScreenService.hide();
  }
}
